import {
	endpointsMap,
	ISetContextOptions,
	ISetContextResponse
} from './ICustomShopperContext';

import AbstractCustomShopperAPI from '../AbstractCustomShopperAPI';
import {ICustomApiConfig} from '../ICustomApiConfig';

/**
 * Represents CustomShopperContext
 */
class CustomShopperContext extends AbstractCustomShopperAPI {
	/**
	 * @constructor
	 * @param {ICustomApiConfig} config - API Config
	 */
	constructor(config: ICustomApiConfig) {
		super(config);
	}

	/**
	 * Sets the custom context for the current customer
	 * @param {ISetContextOptions} fetchOptions - options to pass to API Call
	 * @param {boolean} throwOnError - throw error if api returns error
	 *
	 * @returns {ISetContextResponse} - Array of customer groups
	 */
	public async setCustomerContext(fetchOptions: ISetContextOptions, throwOnError?: boolean): Promise<ISetContextResponse> {
		const response: ISetContextResponse = await this.callCustomEndpoint<ISetContextResponse>(
			fetchOptions,
			endpointsMap.SET_CONTEXT
		);

		if (throwOnError && !response.customerGroups) {
			throw new Error('No customer groups returned.');
		}

		return response;
	}
}

export default CustomShopperContext;
